export default __webpack_public_path__ + "static/image4-24097446f0483d86cf5d58fbffeeb0dc.jpeg";